<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="img"><img alt="image" src="images/p4.jpg"/></p>
<p class="pagebreak"></p>
<p class="center00"><span class="bold">To my brother in bushcraft, PAUL DISNEY:</span></p>
<p class="center">Thank you for the gift of your friendship, and thank you for the countless hours you have spent planning, researching, collecting materials, and teaching bushcraft at my school.</p>
<p class="center">I am deeply grateful for everything you have done to help me.</p>
<p class="center1"><span class="bold">And to my brother in wilderness, MARK HENDRICKS:</span></p>
<p class="center">Thank you for your friendship and support, and thank you so much for the amazing photographs you took for this book. Through your photos, you share your unique view of the natural world, with the eye of an artist and soul of a poet. I wish you all the success in the world.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// intro.vue?2a43a31c